import Joi from 'joi';

export const VALIDATION_PRODUCT_CREATE = {
  options: {allowUnknownBody: false},
  body: {
    name: Joi.string().required(),
    images: Joi.array().items(Joi.string()),
    description: Joi.string(),
    price: Joi.number().required(),
    category: Joi.string().required(),
    subCategory: Joi.string().required(),
    subSubCategory: Joi.string(),
    comparePrice: Joi.number(),
    isChargeTaxes: Joi.boolean(),
    isRequireShip: Joi.boolean(),
    minDepth: Joi.number(),
    maxDepth: Joi.number(),
    minWeight: Joi.number(),
    maxWeight: Joi.number(),
    minWidth: Joi.number(),
    maxWidth: Joi.number(),
    unitWeight: Joi.string(),
    unitWidth: Joi.string(),
    unitDepth: Joi.string(),
    inventorySKU: Joi.string(),
    inventoryBarcode: Joi.string(),
    inventoryPolicy: Joi.string(),
    productType: Joi.string(),
    vendor: Joi.string(),
    brand: Joi.string(),
    shipping: Joi.string(),
    shipsTo: Joi.string(),
    isNewArrived: Joi.boolean(),
    sale: Joi.number(),
    quality: Joi.number(),
    variants: Joi.array().items(Joi.object()),
    sizes: Joi.array().items(Joi.number()),
    colors: Joi.array().items(Joi.string()),
    materials: Joi.array().items(Joi.string()),
    ownerId: Joi.string().required(),
    ownerType: Joi.string().valid('contractor', 'user').required(),
    tags: Joi.array().items(Joi.string()),
    styles: Joi.array().items(Joi.string()),
    collections: Joi.array().items(Joi.string()),
  }
};

export const VALIDATION_PRODUCT_UPDATE = {
  options: {allowUnknownBody: false},
  body: {
    id: Joi.string().required(),
    name: Joi.string(),
    images: Joi.array().items(Joi.string()),
    description: Joi.string(),
    price: Joi.number(),
    category: Joi.string(),
    subCategory: Joi.string(),
    subSubCategory: Joi.string(),
    comparePrice: Joi.number(),
    isChargeTaxes: Joi.boolean(),
    isRequireShip: Joi.boolean(),
    minDepth: Joi.number(),
    maxDepth: Joi.number(),
    minWeight: Joi.number(),
    maxWeight: Joi.number(),
    minWidth: Joi.number(),
    maxWidth: Joi.number(),
    unitWeight: Joi.string(),
    unitWidth: Joi.string(),
    unitDepth: Joi.string(),
    inventorySKU: Joi.string(),
    inventoryBarcode: Joi.string(),
    inventoryPolicy: Joi.string(),
    productType: Joi.string(),
    vendor: Joi.string(),
    brand: Joi.string(),
    shipping: Joi.string(),
    shipsTo: Joi.string(),
    isNewArrived: Joi.boolean(),
    sale: Joi.number(),
    variants: Joi.array().items(Joi.object()),
    sizes: Joi.array().items(Joi.number()),
    colors: Joi.array().items(Joi.string()),
    materials: Joi.array().items(Joi.string()),
    tags: Joi.array().items(Joi.string()),
    styles: Joi.array().items(Joi.string()),
    collections: Joi.array().items(Joi.string())
  }
};

export const VALIDATION_PRODUCT_DELETE = {
  options: {allowUnknownBody: false},
  body: {
    id: Joi.string().required(),
    ownerId: Joi.string().required(),
  }
};

export const VALIDATION_PRODUCT_SEARCH = {
  options: {allowUnknownBody: false},
  body: {
    name: Joi.string(),
    minPrice: Joi.number(),
    maxPrice: Joi.number(),
    comparePrice: Joi.number(),
    isChargeTaxes: Joi.boolean(),
    isRequireShip: Joi.boolean(),
    minDepth: Joi.number(),
    maxDepth: Joi.number(),
    minWeight: Joi.number(),
    maxWeight: Joi.number(),
    minWidth: Joi.number(),
    maxWidth: Joi.number(),
    category: Joi.string(),
    subCategory: Joi.string(),
    subSubCategory: Joi.string(),
    // inventorySKU: Joi.string(),
    // inventoryBarcode: Joi.string(),
    // inventoryPolicy: Joi.string(),
    productType: Joi.array().items(Joi.string()),
    vendor: Joi.array().items(Joi.string()),
    manufacturedBy: Joi.array().items(Joi.string()),
    brand: Joi.array().items(Joi.string()),
    shipping: Joi.array().items(Joi.string()),
    shipsTo: Joi.array().items(Joi.string()),
    isNewArrived: Joi.boolean(),
    sale: Joi.number(),
    sizes: Joi.array().items(Joi.number()),
    colors: Joi.array().items(Joi.string()),
    materials: Joi.array().items(Joi.string()),
    tags: Joi.array().items(Joi.string()),
    styles: Joi.array().items(Joi.string()),
    collections: Joi.array().items(Joi.string()),
    orderBy: Joi.string().valid('updatedAt', 'createdAt').required(),
    orderType: Joi.string().valid('ASC', 'DESC').required(),
    filterFollow: Joi.boolean(),
    isPopular: Joi.boolean(),
    isLastActivity: Joi.boolean(),
    isAllTimePopular: Joi.boolean(),
    isRecentFeatured: Joi.boolean(),
    isPriceHighToLow: Joi.boolean(),
    isPriceLowToHigh: Joi.boolean(),
    page: Joi.number().min(1),
  }
};

export const VALIDATION_PRODUCT_LIST = {
  options: {allowUnknownBody: false},
  body: {
    ownerId: Joi.string().required(),
    name: Joi.string(),
    minPrice: Joi.number(),
    maxPrice: Joi.number(),
    comparePrice: Joi.number(),
    isChargeTaxes: Joi.boolean(),
    isRequireShip: Joi.boolean(),
    minDepth: Joi.number(),
    maxDepth: Joi.number(),
    minWeight: Joi.number(),
    maxWeight: Joi.number(),
    minWidth: Joi.number(),
    maxWidth: Joi.number(),
    category: Joi.string(),
    subCategory: Joi.string(),
    // inventorySKU: Joi.string(),
    // inventoryBarcode: Joi.string(),
    // inventoryPolicy: Joi.string(),
    productType: Joi.array().items(Joi.string()),
    vendor: Joi.array().items(Joi.string()),
    manufacturedBy: Joi.array().items(Joi.string()),
    brand: Joi.array().items(Joi.string()),
    sale: Joi.number(),
    sizes: Joi.array().items(Joi.number()),
    colors: Joi.array().items(Joi.string()),
    materials: Joi.array().items(Joi.string()),
    tags: Joi.array().items(Joi.string()),
    styles: Joi.array().items(Joi.string()),
    collections: Joi.array().items(Joi.string()),
    ownerType: Joi.string().valid('contractor', 'user').required(),
    orderBy: Joi.string().valid('updatedAt', 'createdAt').required(),
    orderType: Joi.string().valid('ASC', 'DESC').required(),
    filterFollow: Joi.boolean(),
    isPopular: Joi.boolean(),
    page: Joi.number().min(1),
  }
};

export const VALIDATION_PRODUCT_MY_PRODUCTS = {
  options: {allowUnknownBody: false},
  body: {
    ownerId: Joi.string().required(),
    name: Joi.string(),
    minPrice: Joi.number(),
    maxPrice: Joi.number(),
    comparePrice: Joi.number(),
    isChargeTaxes: Joi.boolean(),
    isRequireShip: Joi.boolean(),
    minDepth: Joi.number(),
    maxDepth: Joi.number(),
    minWeight: Joi.number(),
    maxWeight: Joi.number(),
    minWidth: Joi.number(),
    maxWidth: Joi.number(),
    category: Joi.string(),
    subCategory: Joi.string(),
    // inventorySKU: Joi.string(),
    // inventoryBarcode: Joi.string(),
    // inventoryPolicy: Joi.string(),
    productType: Joi.array().items(Joi.string()),
    vendor: Joi.array().items(Joi.string()),
    manufacturedBy: Joi.array().items(Joi.string()),
    brand: Joi.array().items(Joi.string()),
    sale: Joi.number(),
    quality: Joi.number(),
    sizes: Joi.array().items(Joi.number()),
    colors: Joi.array().items(Joi.string()),
    materials: Joi.array().items(Joi.string()),
    tags: Joi.array().items(Joi.string()),
    styles: Joi.array().items(Joi.string()),
    collections: Joi.array().items(Joi.string()),
    ownerType: Joi.string().valid('contractor', 'user').required(),
    approved: Joi.number(),
    orderBy: Joi.string().valid('updatedAt', 'createdAt').required(),
    orderType: Joi.string().valid('ASC', 'DESC').required(),
    filterFollow: Joi.boolean(),
    isPopular: Joi.boolean(),
    page: Joi.number().min(1),
  }
};

export const VALIDATION_PRODUCT_ADMIN_LIST = {
  options: {allowUnknownBody: false},
  body: {
    ownerId: Joi.string(),
    name: Joi.string(),
    minPrice: Joi.number(),
    maxPrice: Joi.number(),
    comparePrice: Joi.number(),
    isChargeTaxes: Joi.boolean(),
    isRequireShip: Joi.boolean(),
    minDepth: Joi.number(),
    maxDepth: Joi.number(),
    minWeight: Joi.number(),
    maxWeight: Joi.number(),
    minWidth: Joi.number(),
    maxWidth: Joi.number(),
    category: Joi.string(),
    subCategory: Joi.string(),
    // inventorySKU: Joi.string(),
    // inventoryBarcode: Joi.string(),
    // inventoryPolicy: Joi.string(),
    productType: Joi.array().items(Joi.string()),
    vendor: Joi.array().items(Joi.string()),
    manufacturedBy: Joi.array().items(Joi.string()),
    brand: Joi.array().items(Joi.string()),
    sale: Joi.number(),
    sizes: Joi.array().items(Joi.number()),
    colors: Joi.array().items(Joi.string()),
    materials: Joi.array().items(Joi.string()),
    tags: Joi.array().items(Joi.string()),
    styles: Joi.array().items(Joi.string()),
    collections: Joi.array().items(Joi.string()),
    ownerType: Joi.string().valid('contractor', 'user'),
    approved: Joi.number(),
    orderBy: Joi.string().valid('updatedAt', 'createdAt').required(),
    orderType: Joi.string().valid('ASC', 'DESC').required(),
    filterFollow: Joi.boolean(),
    isPopular: Joi.boolean(),
    page: Joi.number().min(1),
  }
};

export const VALIDATION_PRODUCT_DETAIL_ONE = {
  options: {allowUnknownBody: false},
  params: {
    id: Joi.number().required()
  }
};

export const VALIDATION_PRODUCT_APPROVE = {
  options: {allowUnknownBody: false},
  body: {
    id: Joi.number().required(),
    approved: Joi.boolean().required()
  }
};

export const VALIDATION_PRODUCT_RELATE = {
  options: {allowUnknownBody: false},
  body: {
    id: Joi.number().required()
  }
};

export const VALIDATION_PRODUCT_LIST_SUB_SUB_CATEGORY = {
  options: {allowUnknownBody: false},
  body: {
    subCategory: Joi.string().required()
  }
};

export const VALIDATION_PRODUCT_LIKE_LIKE = {
  options: {allowUnknownBody: false},
  body: {
    id: Joi.number().required()
  }
};

export const VALIDATION_PRODUCT_SHARE = {
  options: {allowUnknownBody: false},
  body: {
    productId: Joi.string(),
    content: Joi.string(),
    emails: Joi.array().items(Joi.string())
  }
};



// WEBPACK FOOTER //
// ./src/services/product/Product.Validator.js